import { render, staticRenderFns } from "./CALogin.vue?vue&type=template&id=681431fe&scoped=true&"
import script from "./CALogin.vue?vue&type=script&lang=js&"
export * from "./CALogin.vue?vue&type=script&lang=js&"
import style0 from "./CALogin.vue?vue&type=style&index=0&id=681431fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681431fe",
  null
  
)

export default component.exports